import * as Yup from 'yup';

export const DepartmentFormValidationSchema = Yup.object().shape({
  departmentName: Yup.string().required('This field is required'),
  responsibleName: Yup.string(),
  emails: Yup.string().required('This field is required'),
});
